import type { DeleteInfo } from './createFileBrowserProvider';

export function buildBatchDeleteConfirmationMessage(
  infos: readonly Pick<DeleteInfo, 'isDirectory'>[]
): string {
  const folderCount = infos.filter((info) => info.isDirectory).length;
  const fileCount = infos.length - folderCount;
  const counts = [
    fileCount > 0 ? `${fileCount} file${fileCount === 1 ? '' : 's'}` : '',
    folderCount > 0 ? `${folderCount} folder${folderCount === 1 ? '' : 's'}` : ''
  ].filter(Boolean);
  const recursiveWarning =
    folderCount > 0
      ? '<br><br>Selected folders and everything inside them will be deleted recursively.'
      : '';

  return `Delete <strong>${infos.length} selected items</strong> (${counts.join(', ')})?${recursiveWarning}`;
}
